import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsPermissionsRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-permissions',
	path: '/plugins/servlet/project-config/:projectKey/permissions',
};
